<app-header />
<main>
  <router-outlet />
</main>
<app-footer />
<app-signup-prompt-modal />
<app-toast />
